module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-kids-2c0feb179b150710f585eb298944df86.webp";